import { DateTime } from 'luxon';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
class DateLainer extends Vue {
    static SERVER_TIMEZONE = 'UTC';
    static CLIENT_TIMEZONE = 'local';
    static LOCALE_FORMAT = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    };

    // Компактный числовой формат для табличных колонок: 20.08.2026, 07:15
    static SHORT_FORMAT = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    };

    static HISTORY_FORMAT = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    };

    $_toLocalDate($date) {
        return DateTime.fromSQL($date, { zone: DateLainer.SERVER_TIMEZONE })
            .setZone(DateLainer.CLIENT_TIMEZONE)
            .toLocaleString(DateLainer.LOCALE_FORMAT);
    }

    $_toLocalDateShort($date) {
        return DateTime.fromSQL($date, { zone: DateLainer.SERVER_TIMEZONE })
            .setZone(DateLainer.CLIENT_TIMEZONE)
            .toLocaleString(DateLainer.SHORT_FORMAT);
    }

    $_toLocalDateHistory($date) {
        return DateTime.fromSQL($date, { zone: DateLainer.SERVER_TIMEZONE })
            .setZone(DateLainer.CLIENT_TIMEZONE)
            .toLocaleString(DateLainer.HISTORY_FORMAT);
    }

    $_toLocalRelativeDate($date) {
        return DateTime.fromSQL($date, { zone: DateLainer.SERVER_TIMEZONE })
            .setZone(DateLainer.CLIENT_TIMEZONE)
            .toRelative({
                padding: -1000,
            });
    }
}

Vue.mixin(DateLainer);

export { DateLainer };
